import { Injectable } from "@angular/core";

import { DCustomFormControl } from "../entities/custom-form-control";
import { DFormControl } from "../entities/form-control";
import * as utils from "../utils/utils";

@Injectable()
export class FormFieldFactory {
	private customControls = new Map<string, DCustomFormControl>();

	register(control: DCustomFormControl) {
		this.customControls.set(control.name, control);
	}

	getCustomControl(config: DFormControl) {
		const control = this.customControls.get(config.type);

		if (!control) {
			return;
		}

		const customConfig = {
			...control,
		};

		// Iterate over the input bindings and replace the values
		for (const prop of Object.keys(customConfig["@input"])) {
			const def = customConfig["@input"][prop];
			customConfig["@input"][prop] = config[prop] || def;
		}

		// Interpolate all the inputs
		if (customConfig["@input"]) {
			// Interpolate
			for (const c of customConfig.definition) {
				utils.interpolate(c, customConfig["@input"]);
			}
		}

		return customConfig;
	}
}
